import withFeatureBranch from '../../redux/flags/withFeatureBranch';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupDesktopV2 from '../VerificationPopupDesktop_v2';
export default withFeatureBranch({
    verification_popup_updates: VerificationPopupDesktopV2,
})(VerificationPopupDesktop);
//# sourceMappingURL=index.js.map